<template>
    <div id="promoters-components">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <modal-agents-for-promoter
                v-show="modalAgents"
                v-if="modalAgents"
                :promoter_id="itemId"/>

            <modal-stationery
                v-show="modalStationery"
                v-if="modalStationery"
                :supplier_id="itemId"
                :role_id="role_id"
                :folder_id="5"/>

            <modal-notes
                v-show="modalNotes"
                v-if="modalNotes"
                :user_id="user_id"
                :role_id="role_id"
                :supplier_id="itemId"/>

            <form v-show="modalForm" id="formPromoter" class="animated fadeIn margin-al-inputs formPromoter">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="promoter.currentName">
                    <input type="hidden" name="currentEmail" v-model="promoter.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="promoter.currentUserName">
                    <input type="hidden" name="currentFile" v-model="promoter.currentFile">
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="promoter.picture" :src="'../storage/promoters/'+promoter.picture" alt=""
                                 class="rounded-circle">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                                <span class="btn btn-file">
                                    Imagen de Perfil <br> <i class="fas fa-upload"></i> <input type="file"
                                                                                               data-label="avatar"
                                                                                               name="imgUser"
                                                                                               v-on:change="getLogo"
                                                                                               placeholder="avatar">
                                </span>
                            <span class="label-file-papeleria alert alert-info logo"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usara para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <hr>
                <h2 class="cabeza">Datos Generales</h2>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-3">
                        <select v-model="promoter.tipo_per" id="tipoPer" class="required" data-select="on"
                                data-name-input="Tipo de Persona" name="tipo_per">
                            <option :value="0">Selecciona un tipo de persona</option>
                            <option :value="1">Física</option>
                            <option :value="2">Moral</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <input name="nmPromotor" id="nmPromotor" class="al-inputs required scr-input"
                               placeholder="Nombre Comercial" v-model="promoter.nmPromotor"/>
                        <label for="nmPromotor" class="scr-supertext">Nombre Comercial</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input name="nombre" id="nombre" class="al-inputs required scr-input" placeholder="Nombre"
                               v-model="promoter.nombre"/>
                        <label for="nombre" class="scr-supertext">Nombre</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="email" name="correo" id="correo" class="al-inputs  scr-input" placeholder="Correo"
                               v-model="promoter.correo"/>
                        <label for="correo" class="scr-supertext">Correo</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="tel" name="telefono" id="telefono" class="al-inputs scr-input"
                               placeholder="Teléfono" v-model="promoter.telefono"/>
                        <label for="telefono" class="scr-supertext">Teléfono</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-name-input="Estado" name="estado" id="estado" data-select="on" class="required"
                                v-on:change="selectCities($event)" v-model="promoter.estado">
                            <option :value="0">Seleccionar un estado</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">{{
                                    state.estado
                                }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-name-input="Ciudad" name="ciudad" id="ciudad" data-select="on" class="required"
                                v-model="promoter.ciudad">
                            <option :value="0">Seleccionar una ciudad</option>
                            <option v-for="city in cities" :value="city.id" :key="city.id">{{ city.ciudad }}</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-name-input="Status" name="status" id="status" data-select="on" class="required"
                                v-model="promoter.status">
                            <option :value="0">Selecciona un status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-3">
                        <input type="number" name="comision" id="comision" placeholder="Comisión"
                               class="al-inputs scr-input" v-model="promoter.comision">
                        <label for="comision" class="scr-supertext">Comisión</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="email" v-model="promoter.f_i_c" name="f_i_c" maxlength="10" type="date"
                               class="al-inputs scr-input" placeholder="Fecha Inicio Contrato*"/>
                        <label for="email" class="scr-supertext">Fecha Inicio Contrato</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="iva_promotor" name="iva_promotor" type="number" class="al-inputs inputDate scr-input"
                               placeholder="Iva" v-model="promoter.iva_promotor"/>
                        <label for="iva_promotor" class="scr-supertext">Iva Promotor</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Administrativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_legal" v-model="promoter.rep_legal" name="rep_legal" type="text"
                                       class="al-inputs scr-input" placeholder="Nombre*"/>
                                <label for="rep_legal" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_email" v-model="promoter.rep_email" name="rep_email" type="text"
                                       class="al-inputs scr-input" placeholder="E-mail*"/>
                                <label for="rep_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_tel" v-model="promoter.rep_tel" name="rep_tel" type="text"
                                       class="al-inputs scr-input" placeholder="Teléfono*"/>
                                <label for="rep_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Operativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_nombre" v-model="promoter.rep_sec_nombre" name="rep_sec_nombre"
                                       type="text" class="al-inputs scr-input" placeholder="Nombre*"/>
                                <label for="rep_sec_nombre" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_email" v-model="promoter.rep_sec_email" name="rep_sec_email"
                                       type="text" class="al-inputs scr-input" placeholder="E-mail*"/>
                                <label for="rep_sec_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_tel" v-model="promoter.rep_sec_tel" name="rep_sec_tel" type="text"
                                       class="al-inputs scr-input" placeholder="Teléfono*"/>
                                <label for="rep_sec_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-3">
                        <input id="username" name="username" type="text" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Usuario" v-model="promoter.username"/>
                        <label for="username" class="scr-supertext">Usuario</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de usuario. La misma que se usa para iniciar
                            sesión.
                        </cite>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="pass" name="password" type="password" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Contraseña" v-model="promoter.password"/>
                        <label for="pass" class="scr-supertext">Contraseña</label>
                        <cite v-if="modificar">
                            Este campo esta habilitado para hacer un cambio de contraseña. La misma que se usa para
                            iniciar sesión.
                        </cite>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>

        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row ">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(Promotoria)="{item}">
                                {{ item.nmPromotor }}
                            </template>
                            <template #cell(E-mail)="{item}">
                        <span v-if="item.reluser">
                            {{ item.reluser.email }}
                        </span>

                            </template>
                            <template #cell(Estado)="{item}">
                        <span v-if="item.reledo">
                            {{ item.reledo.estado }}
                        </span>
                            </template>
                            <template #cell(Status)="{item}">
                            <span v-if="item.status_agente===1"
                                  class="badge rounded-pill text-bg-danger">Inactivo</span>
                                <span v-else class="badge rounded-pill text-bg-success">Activo</span>
                            </template>
                            <template #cell(Comision)="{item}">
                                {{ item.comision }}
                            </template>
                            <template #cell(usuario)="{item}">
                                {{ item.reluser.username }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="itemId=item.id; openModalsProviders('listagents')">Lista de
                                            Agentes</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {promotersService} from "../../Services/Promoters.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "promoters",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            filter: null,
            promoter: {
                id: 0,
                nmPromotor: '',
                nombre: '',
                ciudad: 0,
                estado: 0,
                telefono: '',
                comision: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                f_i_c: '',
                iva_promotor: '',
                picture: '',
                tipo_per: 0,
                status: 0,
                user_id: 0,
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            fields: [
                {key: 'Promotoria'},
                {key: 'E-mail'},
                {key: 'Estado'},
                {key: 'Status'},
                {key: 'Comision'},
                {key: 'usuario'},
                {key: 'Acciones'}
            ],
            states: [],
            cities: [],
            citiesFiscales: [],
            promoters: [],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            tituloBtn: 'Agregar',
            itemId: 0,
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await promotersService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formPromoter');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formPromoter');
                if (this.modificar) {
                    resp = await promotersService.updateOne(this.promoter.id, formData, {isForm: true});
                } else {
                    resp = await promotersService.saveOne(formData, {isForm: true});
                }
                this.modificar = false;
                this.showModal = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.pagination = await promotersService.getMany(this.params);
            this.states = await estadoService.getMany({limit: 0});
            this.promoters = await promotersService.getMany({limit: 0});
            this.isBusy = false;
        },
        async selectCities($e, kind_selected = false) {
            let state_id = this.stateId($e);
            switch (kind_selected) {
                case true:
                    this.citiesFiscales = await statescitiesService.getCitiesByState(state_id);
                    break;
                default:
                    this.cities = await statescitiesService.getCitiesByState(state_id);
                    break;
            }
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar';
                this.selectCities(data.estado);
                this.selectCities(data.estado_domFiscal, true)
                this.promoter = data;
                this.promoter.correo = data.reluser.email;
                this.promoter.estad = data.estado;
                this.promoter.cuidad = data.ciudad;
                this.promoter.ciudad_domFiscal = data.ciudad_domFiscal;
                this.promoter.estado_domFiscal = data.estado_domFiscal;
                this.promoter.currentName = data.nmPromotor;
                this.promoter.currentEmail = data.reluser.email;
                this.promoter.currentUserName = data.reluser.username;
                this.promoter.username = data.reluser.username
                this.promoter.currentFile = data.picture;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.promoter = {
                id: 0,
                nmPromotor: '',
                nombre: '',
                ciudad: 0,
                estado: 0,
                telefono: '',
                comision: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                f_i_c: '',
                picture: '',
                iva_promotor: '',
                status: 0,
                user_id: 0,
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentFile: '',
            }
        }
    },
    mounted() {
        this.index();
    }
}
</script>
